export const STANDARD = 'standard'
export const NON_STANDARD = 'non_standard'
export const OTHER = 'other'

export const ALL_UNIT_HANDOVER_TYPES = [STANDARD, NON_STANDARD, OTHER] as const

export type UnitHandoverType = (typeof ALL_UNIT_HANDOVER_TYPES)[number]
